import { Autocomplete, Button, Grid, Paper, TextField, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import { Controller, FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { ReplayRounded, SearchRounded } from "@mui/icons-material";

const RoyaltiesFilter = ({searchRoyaltiesForm, handleSearch}: any) => {
    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);

    const {globalData, dispatchGlobalData} = useContext(GlobalContext);
    const legalEntities = globalData.user?.legalEntities;
    const [dealers, setDealers] = useState<any[]>([]);

    const {errors} = searchRoyaltiesForm.formState;

    const handleResetForm = () => {
        searchRoyaltiesForm.reset();
        handleSearch({});
    }

    return (
        <Paper elevation={1} sx={{p: theme.spacing(2), mb: theme.spacing(2)}}>
            <FormProvider {...searchRoyaltiesForm}>
                <form onSubmit={searchRoyaltiesForm.handleSubmit(handleSearch)}>
                    <Grid container columnSpacing={2}>

                        {legalEntities.length > 1 &&
                            <Grid item md={3} xs={12}>
                                <Controller
                                    control={searchRoyaltiesForm.control}
                                    name="tenants"
                                    render={({field: {onChange, value}}: any) => (
                                        <Autocomplete
                                            limitTags={1}
                                            disableCloseOnSelect={true}
                                            multiple
                                            id={'tenants'}
                                            options={legalEntities}
                                            value={value || []}
                                            getOptionLabel={(option: any) => t('translation:legalEntities.'.concat(option.name))}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                            label={t("searchDms.form.label.legalEntities")}
                                                            error={Boolean(errors?.tenants)}
                                                            helperText={t(errors?.tenants?.message as string)}
                                                />
                                            )}
                                            onChange={(event, value) => {
                                                let tmpDealers = globalData.user?.dealers?.filter((dealer: any) => {
                                                    if (value?.length > 0) {
                                                        return value?.find((legalEntity: any) => legalEntity.id === dealer.legalEntities[0].id);
                                                    } else {
                                                        return dealer;
                                                    }
                                                });
                                                setDealers(tmpDealers);
                                                searchRoyaltiesForm.setValue('dealers', []);
                                                onChange( value);
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        }

                        { /* used for alignment purposes only */ }
                        <Grid item md={3} xs={12}></Grid>
                        <Grid item md={3} xs={12}></Grid>

                        <Grid item xs={6} md={3} sx={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                            <Button
                                variant="text"
                                color="accent"
                                startIcon={<ReplayRounded />}
                                sx={{mx: theme.spacing(0.5)}}
                                onClick={handleResetForm}
                            >
                                {t('Reset')}
                            </Button>

                            <Button
                                size="icon"
                                color="accent"
                                type="submit"
                                onClick={searchRoyaltiesForm.handleSubmit(handleSearch)}
                                sx={{ml: theme.spacing(0.5)}}
                            >
                                <SearchRounded />
                            </Button>
                        </Grid>

                    </Grid>
                </form>
            </FormProvider>
        </Paper>
    )
}

export default RoyaltiesFilter;
